import { render, staticRenderFns } from "./testOrder.vue?vue&type=template&id=654f3f78&scoped=true&"
import script from "./testOrder.vue?vue&type=script&lang=js&"
export * from "./testOrder.vue?vue&type=script&lang=js&"
import style0 from "./testOrder.vue?vue&type=style&index=0&id=654f3f78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f3f78",
  null
  
)

export default component.exports